import { render, staticRenderFns } from "./SalesBstk.vue?vue&type=template&id=93786b52&"
import script from "./SalesBstk.vue?vue&type=script&lang=js&"
export * from "./SalesBstk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports